import { combineReducers } from 'redux';
import {
	userReducers,
	generalReducers,
	businessReducers,
	notificationReducers,
	messagesReducers,
	packageReducers,
	categoryReducers,
	fileReducers,
	servicesreducers,
	couponReducers,
	locationReducers,
	commentsReducers,
	ticketReducers,
	financialReducers,
	questionReducers,
	reportsReducers,
	walletPaymentReducers,
} from 'Ducks';

const rootReducers = combineReducers({
	user: userReducers,
	general: generalReducers,
	business: businessReducers,
	messages: messagesReducers,
	notification: notificationReducers,
	package: packageReducers,
	category: categoryReducers,
	file: fileReducers,
	services: servicesreducers,
	coupons: couponReducers,
	location: locationReducers,
	comments: commentsReducers,
	ticket: ticketReducers,
	financial: financialReducers,
	question: questionReducers,
	reports: reportsReducers,
	walletPayment: walletPaymentReducers,
});

export default rootReducers;
